module.exports = __webpack_public_path__ + "assets/img/live34.63a65a20.png";